// extracted by mini-css-extract-plugin
module.exports = {"box":"box___2_pxp","item":"item___3mvaN"};